import * as _ from 'lodash';
import {ServerFormUrl} from '../models/servers';
import {Action} from '@ngrx/store';
import {LoadServerURLSuccessAction, serverURLActionTypes} from '../actions/servers-url';

export interface ServerUrlState {
  array: ServerFormUrl[];
}

const initialState: ServerUrlState = {
  array: []
};

export function ServerUrlReducer(state: ServerUrlState = initialState, action: Action): ServerUrlState {
  switch (action.type) {
    case serverURLActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case serverURLActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ServerUrlState, action: LoadServerURLSuccessAction): ServerUrlState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: ServerUrlState): ServerUrlState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const serverUrlSelectors = {
  array: (state: ServerUrlState) => _.get(state, 'array', [])
};
